import { FC } from 'react';

type Props = { variant: 'no-alarms' | 'no-matches'; onClearFilters?: () => void };

export const EmptyState: FC<Props> = ({ variant, onClearFilters }) => {
  if (variant === 'no-alarms') {
    return (
      <div className="text-center py-10">
        <div style={{ fontSize: 48 }}>✓</div>
        <h3>Tudo certo!</h3>
        <p className="text-muted">Nenhuma caixa com alarme ativo no momento.</p>
      </div>
    );
  }
  return (
    <div className="text-center py-10">
      <div style={{ fontSize: 48 }}>🔍</div>
      <h3>Nenhuma caixa encontrada</h3>
      <p className="text-muted">Nenhuma caixa encontrada com esses filtros.</p>
      {onClearFilters && (
        <button type="button" className="btn btn-light" onClick={onClearFilters}>
          Limpar filtros
        </button>
      )}
    </div>
  );
};
